
import './styles/quasar.sass'
import '@quasar/extras/material-icons/material-icons.css'
import langTW from 'quasar/lang/zh-TW'
import Notify from 'quasar/src/plugins/Notify.js';;
// To be used on app.use(Quasar, { ... })
export default {
  config: {
    notify:{},
    //dark:true
  },
  plugins: {
    Notify   
  },
  lang:langTW
}